import { getCountry } from '../../../../../trnds/src/utility/utility';
import TruncatedTextCell from '../TruncatedTextCell/TruncatedTextCell';
import styles from './CountryCell.module.css';
import cn from 'classnames';

type Props = {
    countryCode: string | null | undefined;
    className?: string;
};

const CountryCell = ({ countryCode, className }: Props) => {
    const country = getCountry(countryCode);

    if (!country) {
        return <>{'-'}</>;
    }

    return (
        <div className={cn(styles.container, className)}>
            <span className={cn(`fi fi-${country.code.toLowerCase()}`, styles.flagIcon)} />
            <TruncatedTextCell>{country.label}</TruncatedTextCell>
        </div>
    );
};

export default CountryCell;
